<tec-pwcs-layout [class]="{ dark: designService.isDarkMode() }">
    <ng-container content>
        <!-- Notification -->
        @if (!notificationStatus) {
            <tec-tile
                type="status"
                [icon]="showResumeDetails ? 'icon-refresh' : 'icon-info'"
                tagIconStatus="info"
                [title]="title || ('DELAYED_PROCESS_WARNING.TITLE_DEFAULT' | translate: { company: process?.company })"
                [subtitle]="showResumeDetails ? subtitle : ''"
            >
                <tec-link [label]="'PAGE_CHANGE_DEVICE.LINK' | translate" (click)="sendNotification()" />
            </tec-tile>
        }
        <!-- OK -->
        @if (notificationStatus === 'OK') {
            <tec-tile
                type="status"
                tagIconStatus="success"
                [title]="'PAGE_CHANGE_DEVICE.TITLE_OK' | translate"
                [subtitle]="'PAGE_CHANGE_DEVICE.SUBTITLE_OK' | translate: { company: process?.company }"
                icon="icon-check"
            />
        }
        <!-- KO -->
        @if (notificationStatus === 'KO') {
            <tec-tile
                type="status"
                tagIconStatus="error"
                [title]="'PAGE_CHANGE_DEVICE.TITLE_KO' | translate"
                [subtitle]="'PAGE_CHANGE_DEVICE.SUBTITLE_KO' | translate: { company: process?.company }"
                icon="icon-alert"
            />
        }
    </ng-container>
    <ng-container actions>
        <!-- Notification -->
        @if (!notificationStatus) {
            <tec-button
                size="lg"
                [label]="'GENERAL.BUTTON.CONTINUE' | translate"
                (clickEvent)="closeWarning()"
            />
        }
        <!-- KO -->
        @if (notificationStatus === 'KO') {
            <tec-button [label]="'GENERAL.BUTTON.RETRY_SHORT' | translate" (clickEvent)="sendNotification()" />
        }
    </ng-container>
    @if ((designService.configDesign$ | async)?.showWatermark) {
        <tec-watermark type="default" />
    }
</tec-pwcs-layout>
